import { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";
import { logError } from "@/lib/log";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch((err) => logError("Failed to load testimonials", err)); }, []);
  const cards = useMemo(() => items.map((t) => ({ ...t, byline: [t.role !== t.name ? t.role : null, t.org].filter(Boolean).join(" · ") })), [items]);
  if (!cards.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-testid="testimonials-section">
      <div className="max-w-2xl mb-10">
        <span className="overline text-accent">What managers say</span>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-2">Trusted by registered managers, practice managers, responsible individuals and new providers</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((t, i) => (
          <figure key={t.id} className={`relative bg-card border border-border rounded-2xl p-7 shadow-sm flex flex-col ${i % 3 === 1 ? "lg:-translate-y-3" : ""}`} data-testid={`testimonial-${t.id}`}>
            <Quote className="w-8 h-8 text-primary/20 absolute top-5 right-5" />
            <blockquote className="text-sm sm:text-base leading-relaxed flex-1">“{t.quote}”</blockquote>
            <figcaption className="mt-6 pt-5 border-t border-border">
              <p className="font-semibold text-sm">{t.name}</p>
              <p className="text-xs text-muted-foreground">{t.byline}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
